import { IProcurementPlan } from 'types/procurementPlans'
import { Input } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { formatTimeStampToDate } from 'hooks/date/formattedTime'

type Props = {
  procurementPlan: IProcurementPlan
}

export const ProcurementPlansCard = ({ procurementPlan }: Props) => {
  const { id, status, year, updatedAt, publishedAt } = procurementPlan

  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Box
      bgcolor="#FFFFFF"
      padding={2}
      borderRadius={1}
      marginTop={2}
      borderLeft={4}
      borderColor="primary.main"
      display="flex"
      justifyContent="space-between"
      boxShadow={2}
    >
      <Box>
        <Typography variant="caption" fontWeight="bold">
          {t('year')}:
        </Typography>
        <Typography variant="body2">{year}</Typography>
      </Box>

      <Box>
        <Typography variant="caption" fontWeight="bold">
          {t('createdDate')}:
        </Typography>
        {!!publishedAt && (
          <Typography variant="body2">
            {formatTimeStampToDate(publishedAt)}
          </Typography>
        )}
      </Box>

      <Box>
        <Typography variant="caption" fontWeight="bold">
          {t('lastUpdatedDate')}:
        </Typography>
        {!!updatedAt && (
          <Typography variant="body2">{formatTimeStampToDate(updatedAt)}</Typography>
        )}
      </Box>

      <Box>
        <Typography variant="caption" fontWeight="bold">
          {t('status')}:
        </Typography>
        <Typography variant="body2">{t(`procurement-status-${status}`)}</Typography>
      </Box>

      <IconButton
        onClick={() => navigate(`/portal/procurement-plans/${id}/view`)}
        aria-label="view procurement plan"
        color="primary"
      >
        <Input />
      </IconButton>
    </Box>
  )
}
